if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {  
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
  
        //先添加搭售商品
        let reqForm = {};
        reqForm.items = [];
        Array.from(document.querySelectorAll(".tying-product .shopify-product-form")).forEach((formItem) => {
          if(formItem.querySelector(".tying-product__check").checked){
            // Try to get variant ID from input field directly
            const idInput = formItem.querySelector('input[name="id"]');
            let variantId = null;
            
            if (idInput) {
              variantId = idInput.value;
            } else {
              // Fallback to FormData
              const formData = new FormData(formItem);
              variantId = formData.get("id");
            }
            
            // Only include id and quantity for Shopify Cart API, ensure id is integer
            if (variantId) {
              const parsedId = parseInt(variantId, 10);
              let item = {
                id: parsedId,
                quantity: 1
              };
              // Only add if id is a valid number
              if (!isNaN(item.id) && item.id > 0) {
                reqForm.items.push(item);
              } 
            } 
          }
        });
        if(reqForm.items.length > 0){
          try {
            
            // Try adding items one by one using FormData format (like main product)
            const errors = [];
            for (let i = 0; i < reqForm.items.length; i++) {
              const item = reqForm.items[i];
              
              
              try {
                // Use FormData format like the main product does
                const formData = new FormData();
                formData.append('id', item.id);
                formData.append('quantity', item.quantity);
                
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                config.body = formData;
                
                const formResponse = await fetch(`${routes.cart_add_url}`, config);
                
                if (!formResponse.ok) {
                  let errorData = {};
                  try {
                    errorData = await formResponse.json();
                  } catch (e) {
                    const errorText = await formResponse.text().catch(() => '');
                    try {
                      errorData = errorText ? JSON.parse(errorText) : {};
                    } catch (parseError) {
                      errorData = { description: errorText || 'Unknown error' };
                    }
                  }
                  errors.push({
                    item: item,
                    status: formResponse.status,
                    error: errorData
                  });
                } else {
                  const responseData = await formResponse.json();
                }
              } catch (error) {
                errors.push({
                  item: item,
                  error: { message: error.message }
                });
              }
            }
            
            if (errors.length > 0) {
              const firstError = errors[0];
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: firstError.item.id,
                errors: firstError.error.errors || firstError.error.description,
                message: firstError.error.message || firstError.error.description || 'Failed to add some bundle products',
              });
              this.handleErrorMessage(firstError.error.description || firstError.error.message || 'Failed to add some bundle products');
              // Don't stop the main product from being added, just log the error
              // this.error = true;
              // this.submitButton.classList.remove('loading');
              // this.submitButton.removeAttribute('aria-disabled');
              // this.querySelector('.loading__spinner').classList.add('hidden');
              // return;
            }
          } catch (error) {
            // Don't stop the main product from being added
            // this.handleErrorMessage('Failed to add bundle products');
            // this.error = true;
            // this.submitButton.classList.remove('loading');
            // this.submitButton.removeAttribute('aria-disabled');
            // this.querySelector('.loading__spinner').classList.add('hidden');
            // return;
          }
        }
        
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
